import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, mergeProps as _mergeProps, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/check-circle.svg'
import _imports_1 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'
import _imports_2 from '@/app/ui/assets/svg/info-red.svg'
import _imports_3 from '@/app/ui/assets/svg/announce-fill.svg'


const _hoisted_1 = { class: "text-12px xxl:text-14px" }
const _hoisted_2 = { class: "flex flex-row mt-4 gap-x-4" }
const _hoisted_3 = { class: "w-1/2" }
const _hoisted_4 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" STT Manual "),
  /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-500 font-normal" }, "(Opsional)")
], -1)
const _hoisted_6 = {
  key: 0,
  class: "ml-1 relative"
}
const _hoisted_7 = { class: "w-1/2" }
const _hoisted_8 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "text-12px xxl:text-14px" }, "Shipment ID", -1)
const _hoisted_10 = { class: "ml-1 relative" }
const _hoisted_11 = { class: "flex flex-row mt-4 gap-x-4" }
const _hoisted_12 = { class: "w-1/2" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_14 = { class: "flex flex-row justify-between mt-4" }
const _hoisted_15 = { class: "flex flex-row mt-4" }
const _hoisted_16 = { class: "w-full mr-4" }
const _hoisted_17 = { class: "flex gap-x-2 pl-1 py-2 text-14px text-green-lp-400" }
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_19 = { class: 
                  'text-red-lp-100 text-12px xxl:text-14px pl-1 py-1 flex gap-x-2 bg-red-lp-1100 rounded-lg my-2'
                 }
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Nomor telah melebihi ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" COD/DFOD per hari. ")
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "w-full flex flex-col text-12px" }, " Nomor handphone baru memiliki batas transaksi COD/DFOD per hari sebesar 10 STT (tidak termasuk CNX) atau total tarif melebihi Rp300.000 ", -1)
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "w-full" }
const _hoisted_27 = { class: "flex gap-x-2 pl-1 py-2 text-14px text-green-lp-400" }
const _hoisted_28 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_29 = { class: "flex flex-row justify-between mt-4" }
const _hoisted_30 = { class: "flex flex-row justify-between mt-4" }
const _hoisted_31 = {
  key: 2,
  class: "text-red-lp-100 text-12px xxl:text-14px mt-1"
}
const _hoisted_32 = {
  key: 0,
  class: "text-red-lp-100 text-12px xxl:text-14px mt-1"
}
const _hoisted_33 = {
  key: 1,
  class: "flex flex-row items-start rounded bg-gray-lp-200 text-gray-lp-800 text-12px xxl:text-14px p-4 space-x-2 mt-2"
}
const _hoisted_34 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "info-red"
}, null, -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("div", null, " Untuk tujuan yang dipilih maksimal 1 koli ", -1)
const _hoisted_36 = {
  key: 0,
  class: "flex flex-row my-6"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "w-1/2" }, null, -1)
const _hoisted_38 = { class: "w-1/2 ml-6" }
const _hoisted_39 = { class: "flex flex-row text-12px xxl:text-14px relative" }
const _hoisted_40 = { class: "w-1/2 mr-4" }
const _hoisted_41 = { class: "p-field-checkbox mt-3" }
const _hoisted_42 = { class: "w-1/2" }
const _hoisted_43 = { class: "p-field-checkbox mt-3" }
const _hoisted_44 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_45 = {
  key: 1,
  class: "flex text-red-lp-100 gap-1 mt-2"
}
const _hoisted_46 = { class: "text-14px" }
const _hoisted_47 = { class: "flex flex-row mt-4" }
const _hoisted_48 = { class: "w-1/2" }
const _hoisted_49 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_50 = /*#__PURE__*/_createVNode("p", null, "Asuransi", -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-normal pl-1" }, "*", -1)
const _hoisted_52 = { class: "ml-1 relative" }
const _hoisted_53 = {
  key: 0,
  class: "text-12px xxl:text-14px text-red-lp-1000 flex gap-x-2 pl-1"
}
const _hoisted_54 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_55 = { class: "flex flex-row mt-4 space-x-4" }
const _hoisted_56 = { class: "w-1/2" }
const _hoisted_57 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_58 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" No Registrasi Pajak (NPWP) "),
  /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-500 font-normal" }, "(Optional)")
], -1)
const _hoisted_59 = { class: "ml-1 relative" }
const _hoisted_60 = { class: "w-1/2" }
const _hoisted_61 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_62 = /*#__PURE__*/_createVNode("p", null, "Status Pengiriman", -1)
const _hoisted_63 = {
  key: 0,
  class: "text-red-lp-300 font-normal pl-1"
}
const _hoisted_64 = {
  key: 1,
  class: "text-gray-lp-500 font-normal pl-1"
}
const _hoisted_65 = { class: "ml-1 relative" }
const _hoisted_66 = {
  key: 0,
  class: "text-12px xxl:text-14px text-red-lp-1000 flex gap-x-2 pl-1"
}
const _hoisted_67 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" Status pengiriman wajib diisi ")
const _hoisted_69 = { class: "flex flex-row text-12px xxl:text-14px relative mt-4 space-x-4" }
const _hoisted_70 = { class: "w-1/2 pr-3" }
const _hoisted_71 = { class: "flex flex-row text-12px xxl:text-14px relative mt-4 space-x-4" }
const _hoisted_72 = { for: "cod" }
const _hoisted_73 = {
  key: 2,
  class: "py-2 px-4 rounded-md bg-yellow-lp-400 flex flex-row items-center gap-x-4 mt-2"
}
const _hoisted_74 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "w-4.5 max-w-none",
  alt: "announce-fill"
}, null, -1)
const _hoisted_75 = {
  key: 0,
  class: "text-14px font-medium font-montserrat text-yellow-lp-500"
}
const _hoisted_76 = {
  key: 1,
  class: "text-14px font-medium font-montserrat text-yellow-lp-500"
}
const _hoisted_77 = { class: "flex flex-row text-12px xxl:text-14px mt-4 space-x-4 items-center" }
const _hoisted_78 = { class: "w-1/2" }
const _hoisted_79 = { class: "flex flex-col bg-gray-lp-700 my-6 py-6 rounded-md" }
const _hoisted_80 = { class: "flex w-full gap-x-6 border-b border-gray-lp-400 py-5 flex-row gap-x-6text-black-lp-300 font-semibold text-12px xxl:text-14px" }
const _hoisted_81 = /*#__PURE__*/_createVNode("div", { class: "w-1/12 text-center" }, " No ", -1)
const _hoisted_82 = { class: "w-3/12" }
const _hoisted_83 = /*#__PURE__*/_createVNode("div", { class: "w-4/12" }, [
  /*#__PURE__*/_createTextVNode(" Dimensi/Paket "),
  /*#__PURE__*/_createVNode("span", { class: "font-normal text-gray-lp-500" }, " (P x L x T)"),
  /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-normal pl-1" }, "*")
], -1)
const _hoisted_84 = /*#__PURE__*/_createVNode("div", { class: "w-2/12" }, " Berat Volume ", -1)
const _hoisted_85 = /*#__PURE__*/_createVNode("div", { class: "w-2/12" }, null, -1)
const _hoisted_86 = { class: "flex w-full items-center gap-x-6 py-2 text-12px xxl:text-14px font-montserrat" }
const _hoisted_87 = { class: "w-1/12 text-center" }
const _hoisted_88 = { class: "w-3/12" }
const _hoisted_89 = { class: "w-4/12" }
const _hoisted_90 = { class: "w-2/12" }
const _hoisted_91 = { class: "w-2/12" }
const _hoisted_92 = { class: "flex w-full flex-row justify-start gap-x-6" }
const _hoisted_93 = /*#__PURE__*/_createVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_94 = { class: "w-9/12 flex flex-row px-4 py-2 rounded-md warningMinimumWeight ml-2 mr-32" }
const _hoisted_95 = { class: "text-gray-lp-300 text-12px font-normal" }
const _hoisted_96 = /*#__PURE__*/_createVNode("div", { class: "w-2/12" }, null, -1)
const _hoisted_97 = { class: "flex w-full flex-row justify-start gap-x-6" }
const _hoisted_98 = /*#__PURE__*/_createVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_99 = { class: "w-9/12 flex flex-row" }
const _hoisted_100 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_101 = { class: "text-red-lp-100 text-12px xxl:text-14px flex gap-x-2" }
const _hoisted_102 = /*#__PURE__*/_createVNode("div", { class: "w-2/12" }, null, -1)
const _hoisted_103 = { class: "my-5" }
const _hoisted_104 = {
  key: 3,
  class: "flex flex-row justify-between text-12px xxl:text-14px px-6 my-6"
}
const _hoisted_105 = /*#__PURE__*/_createTextVNode(" Tambah Barang ")
const _hoisted_106 = { class: "flex flex-col justify-around w-full" }
const _hoisted_107 = { class: "flex flex-row justify-between text-gray-lp-300 font-semibold text-12px xxl:text-14px" }
const _hoisted_108 = /*#__PURE__*/_createTextVNode(" Total Barang ")
const _hoisted_109 = { class: "flex flex-col" }
const _hoisted_110 = /*#__PURE__*/_createTextVNode(" Total Berat Kotor ")
const _hoisted_111 = {
  key: 0,
  class: "text-red-lp-100 text-12px xxl:text-14px"
}
const _hoisted_112 = /*#__PURE__*/_createTextVNode(" Promo Berat ")
const _hoisted_113 = { class: "flex flex-col" }
const _hoisted_114 = /*#__PURE__*/_createTextVNode(" Total Berat Dimensi ")
const _hoisted_115 = {
  key: 0,
  class: "text-red-lp-100 text-12px xxl:text-14px"
}
const _hoisted_116 = /*#__PURE__*/_createTextVNode(" Promo Berat ")
const _hoisted_117 = /*#__PURE__*/_createVNode("div", { class: "border-t-2 mt-4" }, null, -1)
const _hoisted_118 = { class: "flex flex-row justify-between text-gray-lp-300 font-semibold text-12px xxl:text-14px mt-4" }
const _hoisted_119 = /*#__PURE__*/_createTextVNode(" Berat Dikenakan Biaya ")
const _hoisted_120 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_121 = { class: "flex flex-row mt-4" }
const _hoisted_122 = { class: "w-full mr-2" }
const _hoisted_123 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_124 = /*#__PURE__*/_createVNode("p", null, " Piece Per Pack ", -1)
const _hoisted_125 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-normal pl-1" }, "*", -1)
const _hoisted_126 = { class: "ml-1 relative" }
const _hoisted_127 = { class: "w-full ml-2" }
const _hoisted_128 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_129 = /*#__PURE__*/_createVNode("p", null, " Komoditas Selanjutnya ", -1)
const _hoisted_130 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-normal pl-1" }, "*", -1)
const _hoisted_131 = { class: "ml-1 relative" }
const _hoisted_132 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_133 = {
  key: 0,
  class: "text-12px xxl:text-14px text-red-lp-700 border-b-2 border-gray-lp-400 mb-4 pb-4"
}
const _hoisted_134 = { class: "flex flex-row items-center justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_LpInputSearch = _resolveComponent("LpInputSearch")!
  const _component_SelectPhoneCountry = _resolveComponent("SelectPhoneCountry")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_WarningSlaTransportation = _resolveComponent("WarningSlaTransportation")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_BannerProductType = _resolveComponent("BannerProductType")!
  const _component_product_poster = _resolveComponent("product-poster")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Woodpacking = _resolveComponent("Woodpacking")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_InformationCodRetail = _resolveComponent("InformationCodRetail")!
  const _component_InputDimension = _resolveComponent("InputDimension")!
  const _component_DetailCalculation = _resolveComponent("DetailCalculation")!
  const _component_DetailUncalculation = _resolveComponent("DetailUncalculation")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_ModalV2, {
      width: "w-9/12",
      title: _ctx.titleForm,
      onClose: () => _ctx.setEditTerminated(true)
    }, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_Title, { label: "Detail Pengiriman" }),
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _hoisted_5,
                (_ctx.formType === 'manual')
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode("img", {
                        onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpenTooltipManualSTT = true)),
                        onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpenTooltipManualSTT = false)),
                        src: 
                    _ctx.isOpenTooltipManualSTT
                      ? require('@/app/ui/assets/svg/info-red.svg')
                      : require('@/app/ui/assets/svg/info.svg')
                  ,
                        alt: ""
                      }, null, 40, ["src"]),
                      _withDirectives(_createVNode(_component_Tooltip, {
                        title: "STT Manual (Opsional)",
                        message: "Isi jika ingin menggunakan STT Manual.",
                        footer: "",
                        style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.6em"}
                      }, null, 512), [
                        [_vShow, _ctx.isOpenTooltipManualSTT]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_lp_input, {
                isFirstInput: true,
                class: "my-2",
                error: _ctx.error.sttManual,
                errorCaption: _ctx.errorCaptionSttManual,
                disabled: _ctx.isDisabledSttManual,
                onChange: _ctx.validateSttManual,
                modelValue: _ctx.manualBooking.sttManual,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.manualBooking.sttManual = $event))
              }, null, 8, ["error", "errorCaption", "disabled", "onChange", "modelValue"])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode("div", _hoisted_10, [
                  _createVNode("img", {
                    src: 
                    _ctx.isOpenTooltipShipmentID
                      ? require('@/app/ui/assets/svg/info-red.svg')
                      : require('@/app/ui/assets/svg/info.svg')
                  ,
                    alt: ""
                  }, null, 8, ["src"]),
                  _withDirectives(_createVNode(_component_Tooltip, {
                    title: "Shipment ID",
                    message: "Isi Shipment ID dengan kode booking marketplace yang tertera pada paket (XYZ00xxx).",
                    footer: "",
                    style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.6em"}
                  }, null, 512), [
                    [_vShow, false]
                  ])
                ])
              ]),
              _createVNode(_component_lp_input, {
                "model-value": _ctx.shipmentId,
                disabled: true
              }, null, 8, ["model-value"])
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode(_component_DataWrapper, {
                label: "No. Referensi Eksternal",
                optional: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.manualBooking.referenceExternal,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.manualBooking.referenceExternal = $event)),
                    placeholder: "DOR00989",
                    errorCaption: "Mohon isi No. Referensi Eksternal",
                    showMaxLength: true,
                    maxLength: 100
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_13,
          _createVNode("div", _hoisted_14, [
            _createVNode(_component_DataWrapper, {
              label: "Nama Pengirim",
              asterisk: "",
              class: "w-full mr-4"
            }, {
              default: _withCtx(() => [
                (_ctx.urlVersion === 'v2')
                  ? (_openBlock(), _createBlock(_component_SelectSearch, {
                      key: 0,
                      onFocus: _cache[5] || (_cache[5] = 
                e => {
                  _ctx.setFieldIndex(2);
                }
              ),
                      onChange: _ctx.onChooseSenders,
                      onFilter: _cache[6] || (_cache[6] = e => _ctx.setNameCustomer(e, 'senders')),
                      placeholder: "Masukan nama pengirim",
                      class: "mt-2",
                      options: _ctx.senders,
                      modelValue: _ctx.manualBooking.sender,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.manualBooking.sender = $event)),
                      isLoading: _ctx.isLoadingCustomer,
                      keyName: "customerName",
                      keyValue: "customerName",
                      isShowErrorIndicator: _ctx.errorMandatory[2],
                      errorCaption: 
                _ctx.errorMandatory[2] ? 'Nama pengirim wajib diisi' : ''
              ,
                      maxLength: 250
                    }, null, 8, ["onChange", "options", "modelValue", "isLoading", "isShowErrorIndicator", "errorCaption"]))
                  : (_openBlock(), _createBlock(_component_LpInputSearch, {
                      key: 1,
                      class: "my-2",
                      options: _ctx.senders,
                      onFilter: _cache[8] || (_cache[8] = e => _ctx.setNameCustomer(e, 'senders')),
                      onInputFilter: _cache[9] || (_cache[9] = e => _ctx.setCustomer(e, 'senders')),
                      onFocus: _cache[10] || (_cache[10] = 
                e => {
                  _ctx.setFieldIndex(2);
                }
              ),
                      isLoading: _ctx.isLoadingCustomer,
                      keyName: "customerName",
                      secondKeyName: "customerPhoneNumber",
                      keyValue: "customerName",
                      "onUpdate:modelValue": [
                        _ctx.onChooseSenders,
                        _cache[11] || (_cache[11] = ($event: any) => (_ctx.manualBooking.sender = $event))
                      ],
                      placeholder: "Masukan nama pengirim",
                      isShowErrorIndicator: _ctx.errorMandatory[2],
                      errorCaption: 
                _ctx.errorMandatory[2] ? 'Nama pengirim wajib diisi' : ''
              ,
                      modelValue: _ctx.manualBooking.sender,
                      maxLength: 250
                    }, null, 8, ["options", "isLoading", "onUpdate:modelValue", "isShowErrorIndicator", "errorCaption", "modelValue"]))
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: "Nama Penerima",
              asterisk: "",
              class: "w-full"
            }, {
              default: _withCtx(() => [
                (_ctx.urlVersion === 'v2')
                  ? (_openBlock(), _createBlock(_component_SelectSearch, {
                      key: 0,
                      onFocus: _cache[12] || (_cache[12] = 
                e => {
                  _ctx.setFieldIndex(3);
                }
              ),
                      onChange: _ctx.onChooseReceivers,
                      onFilter: _cache[13] || (_cache[13] = e => _ctx.setNameCustomer(e, 'receivers')),
                      placeholder: "Masukan nama penerima",
                      class: "mt-2",
                      options: _ctx.receivers,
                      modelValue: _ctx.manualBooking.receiver,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.manualBooking.receiver = $event)),
                      isLoading: _ctx.isLoadingCustomer,
                      keyName: "customerName",
                      keyValue: "customerName",
                      isShowErrorIndicator: _ctx.errorMandatory[3],
                      errorCaption: 
                _ctx.errorMandatory[3] ? 'Nama penerima wajib diisi' : ''
              ,
                      maxLength: 250
                    }, null, 8, ["onChange", "options", "modelValue", "isLoading", "isShowErrorIndicator", "errorCaption"]))
                  : (_openBlock(), _createBlock(_component_LpInputSearch, {
                      key: 1,
                      class: "my-2",
                      options: _ctx.receivers,
                      onFilter: _cache[15] || (_cache[15] = e => _ctx.setNameCustomer(e, 'receivers')),
                      onInputFilter: _cache[16] || (_cache[16] = e => _ctx.setCustomer(e, 'receivers')),
                      onFocus: _cache[17] || (_cache[17] = 
                e => {
                  _ctx.setFieldIndex(3);
                }
              ),
                      isLoading: _ctx.isLoadingCustomer,
                      keyName: "customerName",
                      secondKeyName: "customerPhoneNumber",
                      keyValue: "customerName",
                      "onUpdate:modelValue": [
                        _ctx.onChooseReceivers,
                        _cache[18] || (_cache[18] = ($event: any) => (_ctx.manualBooking.receiver = $event))
                      ],
                      placeholder: "Masukan nama penerima",
                      isShowErrorIndicator: _ctx.errorMandatory[3],
                      errorCaption: 
                _ctx.errorMandatory[3] ? 'Nama penerima wajib diisi' : ''
              ,
                      modelValue: _ctx.manualBooking.receiver,
                      maxLength: 250
                    }, null, 8, ["options", "isLoading", "onUpdate:modelValue", "isShowErrorIndicator", "errorCaption", "modelValue"]))
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, [
              _createVNode(_component_DataWrapper, {
                label: "No. Telepon Pengirim",
                asterisk: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SelectPhoneCountry, {
                    column: "Pengirim",
                    error: _ctx.phoneNumberErrorSender,
                    phone: _ctx.manualBooking.phoneSender,
                    code: _ctx.manualBooking.phoneCodeSender,
                    flag: _ctx.manualBooking.phoneFlagSender,
                    onSetPhone: _ctx.setPhoneSender,
                    onSetPhoneCode: _ctx.setPhoneCodeSender,
                    onSetPhoneFlag: _ctx.setPhoneFlagSender,
                    onSetErrorPhone: _ctx.setErrorPhoneSender,
                    onSetErrorPhoneCode: _ctx.setErrorPhoneCodeSender,
                    onSetErrorCharMinimal: _ctx.setErrorCharMinimalSender,
                    onSetFieldIndex: _cache[19] || (_cache[19] = ($event: any) => (_ctx.setFieldIndex(4)))
                  }, null, 8, ["error", "phone", "code", "flag", "onSetPhone", "onSetPhoneCode", "onSetPhoneFlag", "onSetErrorPhone", "onSetErrorPhoneCode", "onSetErrorCharMinimal"]),
                  _withDirectives(_createVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createTextVNode(" " + _toDisplayString(_ctx.phoneNumberErrorSender.message), 1)
                  ], 512), [
                    [_vShow, 
                  _ctx.phoneNumberErrorSender.success &&
                    _ctx.phoneNumberErrorSender.message &&
                    !(_ctx.fraudError().isLimited || _ctx.fraudError().isSuspected)
                ]
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_19, [
                    _hoisted_20,
                    (_ctx.fraudError().isLimited)
                      ? (_openBlock(), _createBlock("p", _hoisted_21, [
                          _hoisted_22,
                          _createVNode("b", {
                            class: "underline cursor-pointer",
                            onMouseenter: _cache[20] || (_cache[20] = ($event: any) => (_ctx.toggleTooltip($event))),
                            onMouseleave: _cache[21] || (_cache[21] = ($event: any) => (_ctx.toggleTooltip($event)))
                          }, "limit transaksi", 32),
                          _hoisted_23
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_OverlayPanel, {
                      ref: "opTooltip",
                      appendTo: "body",
                      class: "w-1/4",
                      style: {
                    backgroundColor: '#ffffff',
                    color: '#4D4D4D'
                  }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_24
                      ]),
                      _: 1
                    }, 512),
                    (_ctx.fraudError().isSuspected)
                      ? (_openBlock(), _createBlock("p", _hoisted_25, " Nomor memiliki tingkat retur COD/DFOD yang tinggi. "))
                      : _createCommentVNode("", true)
                  ], 512), [
                    [_vShow, _ctx.fraudError().isLimited || _ctx.fraudError().isSuspected]
                  ])
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_26, [
              _createVNode(_component_DataWrapper, {
                label: "No. Telepon Penerima",
                asterisk: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SelectPhoneCountry, {
                    column: "Penerima",
                    error: _ctx.phoneNumberErrorReceiver,
                    phone: _ctx.manualBooking.phoneReceiver,
                    code: _ctx.manualBooking.phoneCodeReceiver,
                    flag: _ctx.manualBooking.phoneFlagReceiver,
                    onSetPhone: _ctx.setPhoneReceiver,
                    onSetPhoneCode: _ctx.setPhoneCodeReceiver,
                    onSetPhoneFlag: _ctx.setPhoneFlagReceiver,
                    onSetErrorPhone: _ctx.setErrorPhoneReceiver,
                    onSetErrorPhoneCode: _ctx.setErrorPhoneCodeReceiver,
                    onSetErrorCharMinimal: _ctx.setErrorCharMinimalReceiver,
                    onSetFieldIndex: _cache[22] || (_cache[22] = ($event: any) => (_ctx.setFieldIndex(5)))
                  }, null, 8, ["error", "phone", "code", "flag", "onSetPhone", "onSetPhoneCode", "onSetPhoneFlag", "onSetErrorPhone", "onSetErrorPhoneCode", "onSetErrorCharMinimal"]),
                  _withDirectives(_createVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createTextVNode(" " + _toDisplayString(_ctx.phoneNumberErrorReceiver.message), 1)
                  ], 512), [
                    [_vShow, 
                  _ctx.phoneNumberErrorReceiver.success &&
                    _ctx.phoneNumberErrorReceiver.message
                ]
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode("div", _hoisted_29, [
            _createVNode(_component_DataWrapper, {
              label: "Alamat Pengirim",
              asterisk: "",
              class: "w-full mr-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  type: "textarea",
                  modelValue: _ctx.manualBooking.addressSender,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.manualBooking.addressSender = $event)),
                  error: 
                _ctx.isShipperAndConsigneeAddressIdentical || _ctx.errorMandatory[6]
              ,
                  "error-caption": 
                _ctx.errorMandatory[6]
                  ? 'Alamat pengirim wajib diisi'
                  : 'Alamat pengirim dan penerima tidak boleh sama'
              ,
                  preventEnterTextArea: true,
                  format: _ctx.replaceNewLine,
                  placeholder: "Masukan alamat pengirim",
                  maxLength: _ctx.maxAddressLength,
                  showMaxLength: true,
                  onFocus: _cache[24] || (_cache[24] = ($event: any) => (_ctx.setFieldIndex(6)))
                }, null, 8, ["modelValue", "error", "error-caption", "format", "maxLength"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: "Alamat Penerima",
              asterisk: "",
              class: "w-full"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  type: "textarea",
                  modelValue: _ctx.manualBooking.addressReceiver,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.manualBooking.addressReceiver = $event)),
                  error: 
                _ctx.isShipperAndConsigneeAddressIdentical || _ctx.errorMandatory[7]
              ,
                  "error-caption": 
                _ctx.errorMandatory[7]
                  ? 'Alamat penerima wajib diisi'
                  : 'Alamat pengirim dan penerima tidak boleh sama'
              ,
                  preventEnterTextArea: true,
                  format: _ctx.replaceNewLine,
                  placeholder: "Masukan alamat penerima",
                  maxLength: _ctx.maxAddressLength,
                  showMaxLength: true,
                  onFocus: _cache[26] || (_cache[26] = ($event: any) => (_ctx.setFieldIndex(7)))
                }, null, 8, ["modelValue", "error", "error-caption", "format", "maxLength"])
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_30, [
            _createVNode(_component_DataWrapper, {
              label: "Kecamatan, Kota Asal",
              asterisk: "",
              class: "w-full mr-4"
            }, {
              default: _withCtx(() => [
                (
                _ctx.getAccount.accountType === 'partner' ||
                  _ctx.getAccount.accountType === 'client'
              )
                  ? (_openBlock(), _createBlock(_component_lp_input, {
                      key: 0,
                      modelValue: _ctx.origin.name,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.origin.name = $event)),
                      placeholder: "Ketik atau pilih alamat asal",
                      disabled: "",
                      error: _ctx.errorEmbargo.originCity
                    }, null, 8, ["modelValue", "error"]))
                  : _createCommentVNode("", true),
                (_ctx.getAccount.accountType === 'internal')
                  ? (_openBlock(), _createBlock(_component_SelectSearch, {
                      key: 1,
                      class: "mt-2",
                      onFilter: _ctx.fetchDestinationCity,
                      isLoading: _ctx.isLoadingOriginCity,
                      options: _ctx.originCityList,
                      keyName: "name",
                      keyValue: "id",
                      placeholder: "Ketik atau pilih alamat asal",
                      modelValue: _ctx.manualBooking.originCity,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.manualBooking.originCity = $event)),
                      onChange: _ctx.onUpdateEmbargoStatusFail,
                      isShowErrorIndicator: 
                _ctx.errorEmbargo.originCity || _ctx.errorMandatory[8]
              ,
                      onFocus: _cache[29] || (_cache[29] = ($event: any) => (_ctx.setFieldIndex(8))),
                      errorCaption: 
                _ctx.errorMandatory[8] ? 'Kecamatan, Kota Asal wajib diisi' : ''
              ,
                      isShowErrorMessage: false
                    }, null, 8, ["onFilter", "isLoading", "options", "modelValue", "onChange", "isShowErrorIndicator", "errorCaption"]))
                  : _createCommentVNode("", true),
                (_ctx.manualBooking.originCity?.status === 'INACTIVE')
                  ? (_openBlock(), _createBlock("div", _hoisted_31, " Kota dan atau Kecamatan Tidak Aktif "))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: "Kecamatan, Kota Tujuan",
              asterisk: "",
              class: "w-full"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectSearch, {
                  class: "mt-2",
                  onFilter: _ctx.fetchDestinationCity,
                  isLoading: _ctx.isLoadingDestinationCity,
                  options: _ctx.destinationCityList,
                  keyName: "name",
                  keyValue: "id",
                  placeholder: "Ketik atau pilih alamat tujuan",
                  modelValue: _ctx.manualBooking.destinationCity,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.manualBooking.destinationCity = $event)),
                  isShowErrorIndicator: 
                _ctx.errorDestinationCity ||
                  _ctx.errorEmbargo.destinationCity ||
                  _ctx.errorMandatory[9]
              ,
                  onFocus: _cache[31] || (_cache[31] = ($event: any) => (_ctx.setFieldIndex(9))),
                  errorCaption: 
                _ctx.errorMandatory[9] ? 'Kecamatan, Kota Tujuan wajib diisi' : ''
              ,
                  isShowErrorMessage: false,
                  onChange: _ctx.handleErrorDestinationCity
                }, null, 8, ["onFilter", "isLoading", "options", "modelValue", "isShowErrorIndicator", "errorCaption", "onChange"]),
                (_ctx.manualBooking.destinationCity?.status === 'INACTIVE')
                  ? (_openBlock(), _createBlock("div", _hoisted_32, " Kota dan atau Kecamatan Tidak Aktif "))
                  : _createCommentVNode("", true),
                (_ctx.checkVendorDestinationDistrict())
                  ? (_openBlock(), _createBlock("div", _hoisted_33, [
                      _hoisted_34,
                      _hoisted_35
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _withDirectives(_createVNode(_component_WarningSlaTransportation, _mergeProps(_ctx.estimateSla, { class: "mt-1" }), null, 16), [
            [_vShow, _ctx.isShowWarningSla]
          ]),
          (_ctx.isPostalCodeFieldShow)
            ? (_openBlock(), _createBlock("div", _hoisted_36, [
                _hoisted_37,
                _createVNode("div", _hoisted_38, [
                  _createVNode(_component_DataWrapper, {
                    label: "Kode Pos",
                    asterisk: "",
                    class: "w-full"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SelectSearch, {
                        serverSide: false,
                        onFocus: _cache[32] || (_cache[32] = ($event: any) => (_ctx.setFieldIndex(9.5))),
                        onFilter: _ctx.setPostalCodeDestination,
                        placeholder: "Masukan kode pos",
                        class: "mt-2",
                        keyName: "name",
                        keyValue: "id",
                        options: _ctx.postalCodeDestinationOptions,
                        modelValue: _ctx.manualBooking.postalCodeDestination,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.manualBooking.postalCodeDestination = $event)),
                        isShowErrorIndicator: 
                  _ctx.currentFieldIndex > 9.5 &&
                    !_ctx.manualBooking.postalCodeDestination
                ,
                        errorCaption: 
                  _ctx.currentFieldIndex > 9.5 &&
                  !_ctx.manualBooking.postalCodeDestination
                    ? 'Kode Pos wajib diisi'
                    : ''
                
                      }, null, 8, ["onFilter", "options", "modelValue", "isShowErrorIndicator", "errorCaption"])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_39, [
            _createVNode("div", _hoisted_40, [
              _createVNode("div", _hoisted_41, [
                _createVNode(_component_Checkbox, {
                  id: "sender",
                  modelValue: _ctx.manualBooking.isSaveSender,
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.manualBooking.isSaveSender = $event)),
                  binary: true,
                  onFocus: _cache[35] || (_cache[35] = ($event: any) => (_ctx.onSaveCustomer($event, 'sender'))),
                  disabled: _ctx.disableSaveSender
                }, null, 8, ["modelValue", "disabled"]),
                _createVNode("label", {
                  class: "ml-2.5",
                  for: "sender",
                  style: `${_ctx.disableSaveSender ? `color:#9e9e9e` : ''}`
                }, "Simpan Data Pengirim", 4)
              ])
            ]),
            _createVNode("div", _hoisted_42, [
              _createVNode("div", _hoisted_43, [
                _createVNode(_component_Checkbox, {
                  id: "receiver",
                  modelValue: _ctx.manualBooking.isSaveReceiver,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.manualBooking.isSaveReceiver = $event)),
                  binary: true,
                  onFocus: _cache[37] || (_cache[37] = ($event: any) => (_ctx.onSaveCustomer($event, 'receiver'))),
                  disabled: _ctx.disableSaveReceiver
                }, null, 8, ["modelValue", "disabled"]),
                _createVNode("label", {
                  class: "ml-2.5",
                  for: "receiver",
                  style: `${_ctx.disableSaveReceiver ? `color:#9e9e9e` : ''}`
                }, "Simpan Data Penerima", 4)
              ])
            ])
          ]),
          _hoisted_44,
          _createVNode(_component_Title, { label: "Detail Barang" }),
          _createVNode(_component_BannerProductType, { class: "mt-8" }),
          _createVNode(_component_DataWrapper, {
            label: "Jenis Pengiriman",
            asterisk: "",
            class: "w-full mr-4 mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_product_poster, {
                class: "mt-3",
                ref: "renderPoster",
                productType: _ctx.manualBooking.productName.toLowerCase() === 'jumbopackh2h' ? 'jumbopack' : _ctx.manualBooking.productName.toLowerCase(),
                onChoseeProduct: _ctx.onSelectProduct,
                onSetErrorTriggered: _ctx.setErrorDestintaionProductUpselling,
                isOnePack: true,
                isJumboPack: _ctx.manualBooking.productName.toLowerCase() === 'jumbopack' || _ctx.manualBooking.productName.toLowerCase() === 'jumbopackh2h'
              }, null, 8, ["productType", "onChoseeProduct", "onSetErrorTriggered", "isJumboPack"])
            ]),
            _: 1
          }),
          (_ctx.errorProduct)
            ? (_openBlock(), _createBlock("div", _hoisted_45, [
                _createVNode(_component_Icons, {
                  name: "warning-triangle",
                  class: " w-4"
                }),
                _createVNode("p", _hoisted_46, _toDisplayString(_ctx.errorProduct), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_47, [
            _createVNode(_component_DataWrapper, {
              label: "Tipe Komoditas",
              asterisk: "",
              class: "w-1/2 mr-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectSearch, {
                  class: "mt-2",
                  options: _ctx.commodities,
                  onFilter: _ctx.fetchCommodityList,
                  keyName: "name",
                  keyValue: "code",
                  placeholder: "Ketik atau pilih nama komoditas",
                  modelValue: _ctx.manualBooking.commodityCode,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.manualBooking.commodityCode = $event)),
                  isShowErrorMessage: false,
                  isShowErrorIndicator: 
                _ctx.manualBooking.commodityCode?.status === 'inactive' ||
                  _ctx.errorEmbargo.comodity ||
                  _ctx.errorMandatory[10]
              ,
                  errorCaption: 
                _ctx.manualBooking.commodityCode?.status === 'inactive'
                  ? `Komoditas ini tidak aktif`
                  : _ctx.errorMandatory[10]
                  ? `Tipe komoditas wajib diisi`
                  : ''
              ,
                  onChange: _cache[39] || (_cache[39] = () => {
                _ctx.onUpdateEmbargoStatusFail();
                _ctx.setHwsCommodity();
              }),
                  onFocus: _cache[40] || (_cache[40] = ($event: any) => (_ctx.setFieldIndex(10)))
                }, null, 8, ["options", "onFilter", "modelValue", "isShowErrorIndicator", "errorCaption"])
              ]),
              _: 1
            }),
            _createVNode("div", _hoisted_48, [
              _createVNode("div", _hoisted_49, [
                _hoisted_50,
                _hoisted_51,
                _createVNode("div", _hoisted_52, [
                  _createVNode("img", {
                    onMouseenter: _cache[41] || (_cache[41] = ($event: any) => (_ctx.isOpenTooltipInsurance = true)),
                    onMouseleave: _cache[42] || (_cache[42] = ($event: any) => (_ctx.isOpenTooltipInsurance = false)),
                    src: 
                    _ctx.isOpenTooltipInsurance
                      ? require('@/app/ui/assets/svg/info-red.svg')
                      : require('@/app/ui/assets/svg/info.svg')
                  ,
                    alt: ""
                  }, null, 40, ["src"]),
                  _withDirectives(_createVNode(_component_Tooltip, {
                    title: "Asuransi",
                    message: "Asuransi akan memproteksi barang yang rusak/hilang sesuai dengan S&K yang berlaku. Biaya asuransi akan otomatis terakumulasi pada Total Tarif.",
                    footer: "",
                    style: {"width":"280px","margin-left":"2.6em","margin-top":"-2.6em"}
                  }, null, 512), [
                    [_vShow, _ctx.isOpenTooltipInsurance]
                  ])
                ])
              ]),
              _createVNode(_component_Select, {
                "is-disabled": !_ctx.isShipmentInsuranceEnable || _ctx.disabledInsurance,
                onOpenSelect: 
                () => {
                  _ctx.onOpenSelectInsurance();
                  _ctx.setFieldIndex(12);
                }
              ,
                onCloseSelect: _ctx.onCloseSelectInsurance,
                isOpenMenu: _ctx.isOpenSelectInsurance,
                value: _ctx.insuranceAsDefault,
                onChooseSelect: _ctx.onSelectStatusInsurance,
                dataSelect: _ctx.listInsurance,
                class: "w-full whitespace-no-wrap my-2 z-10",
                isError: _ctx.error.insurance || _ctx.errorMandatory[12]
              }, null, 8, ["is-disabled", "onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect", "isError"]),
              (_ctx.error.insurance || _ctx.errorMandatory[12])
                ? (_openBlock(), _createBlock("p", _hoisted_53, [
                    _hoisted_54,
                    _createTextVNode(" " + _toDisplayString(_ctx.errorMandatory[12]
                  ? "Asuransi pengiriman wajib diisi"
                  : "Asuransi tidak aktif"), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_55, [
            _createVNode("div", _hoisted_56, [
              _createVNode("div", _hoisted_57, [
                _hoisted_58,
                _createVNode("div", _hoisted_59, [
                  _createVNode("img", {
                    src: 
                    _ctx.isOpenTooltipTax
                      ? require('@/app/ui/assets/svg/info-red.svg')
                      : require('@/app/ui/assets/svg/info.svg')
                  ,
                    alt: ""
                  }, null, 8, ["src"]),
                  _withDirectives(_createVNode(_component_Tooltip, {
                    title: "No. Registrasi Pajak (NPWP)",
                    message: "Wajib Pajak bisa individu atau perusahaan sesuai dengan yang sudah terdaftar. ",
                    footer: "",
                    isArrowLeft: false,
                    style: {"width":"280px","margin-left":"-20.6em","margin-top":"-2.6em"}
                  }, null, 512), [
                    [_vShow, false]
                  ])
                ])
              ]),
              _createVNode("div", {
                class: { 'opacity-50': !_ctx.isFreeTradeZone }
              }, [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.manualBooking.taxNumber,
                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.manualBooking.taxNumber = $event)),
                  format: _ctx.formatted,
                  onChange: _ctx.validateTaxNumber,
                  errorCaption: "Masukan No. Registrasi Pajak (NPWP) dengan benar",
                  error: _ctx.error.taxNumber,
                  placeholder: "00.000.000.0-000.000",
                  maxLength: 20,
                  "show-max-length": "",
                  disabled: !_ctx.isFreeTradeZone,
                  onBlur: _ctx.handleErrorTaxNumber,
                  onFocus: _cache[44] || (_cache[44] = ($event: any) => (_ctx.setFieldIndex(14)))
                }, null, 8, ["modelValue", "format", "onChange", "error", "disabled", "onBlur"])
              ], 2)
            ]),
            _createVNode("div", _hoisted_60, [
              _createVNode("div", _hoisted_61, [
                _hoisted_62,
                (_ctx.isFtzAccount)
                  ? (_openBlock(), _createBlock("span", _hoisted_63, "*"))
                  : (_openBlock(), _createBlock("span", _hoisted_64, "(Opsional)")),
                _createVNode("div", _hoisted_65, [
                  _createVNode("img", {
                    onMouseenter: _cache[45] || (_cache[45] = ($event: any) => (_ctx.isOpenTooltipStatusGoods = true)),
                    onMouseleave: _cache[46] || (_cache[46] = ($event: any) => (_ctx.isOpenTooltipStatusGoods = false)),
                    src: 
                    _ctx.isOpenTooltipStatusGoods
                      ? require('@/app/ui/assets/svg/info-red.svg')
                      : require('@/app/ui/assets/svg/info.svg')
                  ,
                    alt: ""
                  }, null, 40, ["src"]),
                  _withDirectives(_createVNode(_component_Tooltip, {
                    title: "Status Pengiriman",
                    message: "Status pengiriman berlaku untuk pengiriman dari Kota Asal FTZ. Isi dengan kondisi barang yang akan dikirimkan. ",
                    footer: "",
                    style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.8em"}
                  }, null, 512), [
                    [_vShow, _ctx.isOpenTooltipStatusGoods]
                  ])
                ])
              ]),
              _createVNode(_component_Select, {
                onOpenSelect: 
                () => {
                  _ctx.onOpenSelect();
                  _ctx.setFieldIndex(11);
                }
              ,
                onCloseSelect: _ctx.onCloseSelect,
                isOpenMenu: _ctx.isStatusGoods,
                value: 
                _ctx.formType === 'manual'
                  ? _ctx.manualBooking.statusGoods
                  : _ctx.statusGoodValueForclients
              ,
                onChooseSelect: _ctx.onSelectStatus,
                dataSelect: _ctx.listStatusGoods,
                class: "w-full whitespace-no-wrap my-1.5 z-10",
                isError: _ctx.errorMandatory[11]
              }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect", "isError"]),
              (_ctx.errorMandatory[11])
                ? (_openBlock(), _createBlock("p", _hoisted_66, [
                    _hoisted_67,
                    _hoisted_68
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_69, [
            _createVNode("div", _hoisted_70, [
              _createVNode(_component_DataWrapper, {
                label: "Harga Barang",
                class: "w-full",
                asterisk: _ctx.insuranceAsDefault !== 'free'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.manualBooking.estimationPrice,
                    "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.manualBooking.estimationPrice = $event)),
                    prefix: "IDR",
                    format: _ctx.formatEstimationPrice,
                    onKeydown: _cache[48] || (_cache[48] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                    placeholder: "e.g 20.000",
                    errorIcon: false,
                    onChange: _ctx.fullFilledCOD,
                    error: _ctx.errorMandatory[13] || _ctx.errorEstimationPrice,
                    errorCaption: 
                  _ctx.errorEstimationPrice
                  ? `${_ctx.errMsgPrice}`
                  : 'Harga barang wajib diisi'
                ,
                    onFocus: _cache[49] || (_cache[49] = ($event: any) => (_ctx.setFieldIndex(13)))
                  }, null, 8, ["modelValue", "format", "onChange", "error", "errorCaption"])
                ]),
                _: 1
              }, 8, ["asterisk"])
            ])
          ]),
          _createVNode(_component_Woodpacking, {
            ref: "woodpacking",
            modelValue: _ctx.manualBooking.isWoodpack,
            "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (_ctx.manualBooking.isWoodpack = $event)),
            city: _ctx.cityForWoodPacking,
            isDisabled: "",
            eligibleAccessForShipment: _ctx.woodpackingAccess
          }, null, 8, ["modelValue", "city", "eligibleAccessForShipment"]),
          _createVNode("div", _hoisted_71, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deliveryFeeTypes, (option) => {
              return (_openBlock(), _createBlock("div", {
                key: option.value,
                class: "flex flex-col gap-y-4 mx-2 my-4 city-exclude-radio items-center"
              }, [
                _createVNode("div", {
                  class: 
              `p-field-radiobutton gap-x-3 flex flex-row ${option.logo ? 'items-center' : 'mt-3'}
              ${option.logo === 'dfod-logo' ? 'mt-2' : ''}`
                }, [
                  _createVNode(_component_RadioButton, {
                    id: `radio-${option.value}`,
                    name: "surcharge-status",
                    value: option.value,
                    modelValue: _ctx.deliveryFeeType,
                    "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.deliveryFeeType = $event)),
                    disabled: option.disabled,
                    onChange: ($event: any) => (_ctx.onChangeDeliveryFeeType(option.value))
                  }, null, 8, ["id", "value", "modelValue", "disabled", "onChange"]),
                  _createVNode("label", {
                    for: `radio-${option.value}`,
                    class: `cursor-pointer flex ${option.logo ? 'items-center' : ''}`
                  }, [
                    (option.logo)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          src: require(`@/app/ui/assets/images/${option.logo}.png`),
                          class: "max-w-none w-12 mr-2",
                          alt: "cod-logo"
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true),
                    _createVNode("label", _hoisted_72, _toDisplayString(option.name), 1)
                  ], 10, ["for"])
                ], 2)
              ]))
            }), 128))
          ]),
          (_ctx.fraudError().isBlacklist || _ctx.fraudError().isPhoneNumberFraudLimited)
            ? (_openBlock(), _createBlock("div", _hoisted_73, [
                _hoisted_74,
                (_ctx.fraudError().isBlacklist)
                  ? (_openBlock(), _createBlock("p", _hoisted_75, " Pengirim tidak bisa menggunakan layanan COD/DFOD untuk saat ini, hubungi admin LP. "))
                  : (_ctx.fraudError().isPhoneNumberFraudLimited)
                    ? (_openBlock(), _createBlock("p", _hoisted_76, " Pengirim telah melebihi limit transaksi COD/DFOD. "))
                    : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_77, [
            (_ctx.deliveryFeeType === 'cod')
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  label: "Harga Barang COD",
                  class: "w-1/2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.manualBooking.codAmount,
                      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (_ctx.manualBooking.codAmount = $event)),
                      prefix: "IDR",
                      format: _ctx.formatEstimationPrice,
                      onKeydown: _cache[53] || (_cache[53] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                      placeholder: "0",
                      disableBackground: true,
                      disabled: true,
                      onFocus: _cache[54] || (_cache[54] = ($event: any) => (_ctx.setFieldIndex(14))),
                      error: _ctx.errorEstimationPrice,
                      errorCaption: 
                _ctx.errorEstimationPrice && _ctx.isEligibleCOD ? `${_ctx.errMsgPrice}` : ''
              
                    }, null, 8, ["modelValue", "format", "error", "errorCaption"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_78, [
              (_ctx.deliveryFeeType !== 'non-cod')
                ? (_openBlock(), _createBlock(_component_InformationCodRetail, {
                    key: 0,
                    type: _ctx.deliveryFeeType,
                    class: "max-h-full"
                  }, null, 8, ["type"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_79, [
            _createVNode("div", _hoisted_80, [
              _hoisted_81,
              _createVNode("div", _hoisted_82, [
                _createVNode(_component_DataWrapper, {
                  label: "Berat Barang",
                  suffix: "Kg",
                  tooltipTitle: "Berat Barang (Kg)",
                  tooltipDescription: "Minimum berat barang adalah 1 Kg. Masukan desimal dengan “,” bila dibutuhkan.",
                  isDefault: false
                })
              ]),
              _hoisted_83,
              _hoisted_84,
              _hoisted_85
            ]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listKGs, (key, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index,
                class: "flex flex-col"
              }, [
                _createVNode("div", _hoisted_86, [
                  _createVNode("div", _hoisted_87, _toDisplayString(index + 1), 1),
                  _createVNode("div", _hoisted_88, [
                    _createVNode(_component_lp_input, {
                      modelValue: key.grossWeight,
                      "onUpdate:modelValue": [($event: any) => (key.grossWeight = $event), _ctx.setValidateHWS],
                      format: _ctx.formatFloat,
                      onChange: ($event: any) => (_ctx.onUpdateEmbargoStatusFail($event, index)),
                      placeholder: "e.g 20",
                      maxLength: _ctx.isMaxLengthGrossWeight,
                      error: _ctx.errorEmbargo.weightStatus,
                      onFocus: _cache[55] || (_cache[55] = ($event: any) => (_ctx.setFieldIndex(14)))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "format", "onChange", "maxLength", "error"])
                  ]),
                  _createVNode("div", _hoisted_89, [
                    _createVNode(_component_InputDimension, {
                      length: key.dimension.length,
                      "onUpdate:length": ($event: any) => (key.dimension.length = $event),
                      width: key.dimension.width,
                      "onUpdate:width": ($event: any) => (key.dimension.width = $event),
                      height: key.dimension.height,
                      "onUpdate:height": ($event: any) => (key.dimension.height = $event),
                      onInput: ($event: any) => (_ctx.calculationVolumeWeight(index)),
                      error: _ctx.errorEmbargo.lengthStatus,
                      onChange: _ctx.onUpdateEmbargoStatusFail,
                      onFocus: _cache[56] || (_cache[56] = ($event: any) => (_ctx.setFieldIndex(14))),
                      disabled: key.isDimensionDisabled
                    }, null, 8, ["length", "onUpdate:length", "width", "onUpdate:width", "height", "onUpdate:height", "onInput", "error", "onChange", "disabled"])
                  ]),
                  _createVNode("div", _hoisted_90, _toDisplayString(key.convertVolumeWeight) + " Kg ", 1),
                  _createVNode("div", _hoisted_91, [
                    _withDirectives(_createVNode("div", {
                      onClick: ($event: any) => (_ctx.removeKGs(index)),
                      class: "self-center cursor-pointer ml-3 relative"
                    }, [
                      _createVNode("div", {
                        class: "img-close-icon",
                        onMouseenter: ($event: any) => (_ctx.isHoverEnter(index)),
                        onMouseleave: _cache[57] || (_cache[57] = ($event: any) => (_ctx.isHoverDelete = false))
                      }, [
                        _withDirectives(_createVNode(_component_Tooltip, {
                          message: "Hapus Barang",
                          title: "",
                          footer: "",
                          style: {"width":"135px","margin-left":"1.5em","margin-top":"-1.3em"}
                        }, null, 512), [
                          [_vShow, _ctx.isHoverDelete && index === _ctx.cacheIndex]
                        ])
                      ], 40, ["onMouseenter"])
                    ], 8, ["onClick"]), [
                      [_vShow, _ctx.listKGs.length > 1]
                    ])
                  ])
                ]),
                _withDirectives(_createVNode("div", _hoisted_92, [
                  _hoisted_93,
                  _createVNode("div", _hoisted_94, [
                    _createVNode(_component_Icons, {
                      width: "16",
                      height: "16",
                      name: "announce",
                      class: "mr-2"
                    }),
                    _createVNode("p", _hoisted_95, " Berat diatas " + _toDisplayString(_ctx.minimumHeavyWeightSurcharge.heavyWeightMinimum) + " kg akan dikenakan biaya tambahan & Anda tidak dapat menambah koli lagi. ", 1)
                  ]),
                  _hoisted_96
                ], 512), [
                  [_vShow, key.warningHwsSingle]
                ]),
                _withDirectives(_createVNode("div", _hoisted_97, [
                  _hoisted_98,
                  _createVNode("div", _hoisted_99, [
                    _hoisted_100,
                    _createVNode("p", _hoisted_101, " Berat mulai " + _toDisplayString(_ctx.minimumHeavyWeightSurcharge.heavyWeightMinimum) + " kg hanya 1 koli. Ubah berat atau booking baru. ", 1)
                  ]),
                  _hoisted_102
                ], 512), [
                  [_vShow, key.isErrorHws]
                ]),
                _withDirectives(_createVNode("hr", _hoisted_103, null, 512), [
                  [_vShow, _ctx.listKGs.length > 1]
                ])
              ]))
            }), 128))
          ]),
          (_ctx.isMaxAddKgs)
            ? (_openBlock(), _createBlock("div", _hoisted_104, [
                (
              !_ctx.isVendorNinjaDestination &&
                !_ctx.allowToAddMoreKoli &&
                !_ctx.allowToAddMoreKoliVolume
            )
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.manualBooking.productName === 'INTERPACK' || _ctx.disableAddPiecesHws ? null : _ctx.addKGs())),
                      class: 
              `flex gap-3 ${
                _ctx.manualBooking.productName === 'INTERPACK' || _ctx.disableAddPiecesHws
                  ? 'text-gray-lp-600 cursor-not-allowed'
                  : 'text-red-lp-300 cursor-pointer'
              }`
            
                    }, [
                      _createVNode(_component_Icons, {
                        name: "plus-circle",
                        class: 
                `${
                  _ctx.manualBooking.productName === 'INTERPACK' || _ctx.disableAddPiecesHws
                    ? 'text-gray-lp-600'
                    : 'text-red-lp-300'
                }`
              
                      }, null, 8, ["class"]),
                      _hoisted_105
                    ], 2))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", {
            class: 
            `my-4 bg-gray-lp-700 p-3 rounded-md ${
              _ctx.validateTotalGrossWeight ||
              _ctx.validateTotalVolumeWeight ||
              _ctx.isVendorNinjaDestination
                ? 'border border-red-lp-100'
                : 'p-3 rounded-md'
            }`
          
          }, [
            _createVNode("div", _hoisted_106, [
              _createVNode("div", _hoisted_107, [
                _hoisted_108,
                _createVNode("p", null, _toDisplayString(_ctx.listKGs.length), 1)
              ]),
              _createVNode("div", _hoisted_109, [
                _createVNode("div", {
                  class: 
                  `flex flex-row justify-between text-12px xxl:text-14px mt-4 ${
                    _ctx.isGrossWeight && !_ctx.isCampaign
                      ? 'text-gray-lp-300 font-semibold'
                      : 'text-gray-lp-600 font-normal'
                  }`
                
                }, [
                  _hoisted_110,
                  _createVNode("p", null, _toDisplayString(_ctx.totalGrossWeight) + " Kg", 1)
                ], 2),
                (_ctx.validateTotalGrossWeight)
                  ? (_openBlock(), _createBlock("div", _hoisted_111, " Total berat barang melebihi batas maksimum yaitu 400 Kg/STT "))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode("div", {
                  class: 
                  `flex flex-row justify-between text-12px xxl:text-14px ${
                    _ctx.isGrossWeight && _ctx.isCampaign
                      ? 'text-gray-lp-300 font-semibold'
                      : 'text-gray-lp-600 font-normal'
                  }`
                
                }, [
                  _hoisted_112,
                  _createVNode("p", null, _toDisplayString(_ctx.totalCampaignChargeableWeight.toString().replace(".", ",")) + " Kg ", 1)
                ], 2), [
                  [_vShow, _ctx.isGrossWeight && _ctx.isCampaign]
                ])
              ]),
              _createVNode("div", _hoisted_113, [
                _createVNode("div", {
                  class: 
                  `flex flex-row justify-between text-12px xxl:text-14px mt-4 ${
                    _ctx.isVolumeWeight && !_ctx.isCampaign
                      ? 'text-gray-lp-300 font-semibold'
                      : 'text-gray-lp-600 font-normal'
                  }`
                
                }, [
                  _hoisted_114,
                  _createVNode("p", null, _toDisplayString(_ctx.totalVolumeWeight) + " Kg", 1)
                ], 2),
                (_ctx.validateTotalVolumeWeight)
                  ? (_openBlock(), _createBlock("div", _hoisted_115, " Total berat barang melebihi batas maksimum yaitu 400 Kg/STT "))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode("div", {
                  class: 
                  `flex flex-row justify-between text-12px xxl:text-14px ${
                    _ctx.isVolumeWeight && _ctx.isCampaign
                      ? 'text-gray-lp-300 font-semibold'
                      : 'text-gray-lp-600 font-normal'
                  }`
                
                }, [
                  _hoisted_116,
                  _createVNode("p", null, _toDisplayString(_ctx.totalCampaignChargeableWeight.toString().replace(".", ",")) + " Kg ", 1)
                ], 2), [
                  [_vShow, _ctx.isVolumeWeight && _ctx.isCampaign]
                ])
              ]),
              _hoisted_117,
              _createVNode("div", _hoisted_118, [
                _hoisted_119,
                _createVNode("p", null, _toDisplayString(_ctx.isCampaign
                    ? _ctx.totalCampaignChargeableWeight.toString().replace(".", ",")
                    : _ctx.totalChargeableWeight) + " Kg ", 1)
              ])
            ])
          ], 2),
          _hoisted_120,
          (_ctx.isFtzAccount)
            ? (_openBlock(), _createBlock(_Fragment, { key: 4 }, [
                _createVNode(_component_Title, { label: "Free Trade Zone" }),
                _createVNode("div", _hoisted_121, [
                  _createVNode("div", _hoisted_122, [
                    _createVNode("div", _hoisted_123, [
                      _hoisted_124,
                      _hoisted_125,
                      _createVNode("div", _hoisted_126, [
                        _createVNode("img", {
                          onMouseenter: _cache[59] || (_cache[59] = ($event: any) => (_ctx.isOpenTooltipPiecePerPack = true)),
                          onMouseleave: _cache[60] || (_cache[60] = ($event: any) => (_ctx.isOpenTooltipPiecePerPack = false)),
                          src: 
                      _ctx.isOpenTooltipPiecePerPack
                        ? require('@/app/ui/assets/svg/info-red.svg')
                        : require('@/app/ui/assets/svg/info.svg')
                    ,
                          alt: ""
                        }, null, 40, ["src"]),
                        _withDirectives(_createVNode(_component_Tooltip, {
                          title: "Piece Per Pack",
                          message: "Piece per pack adalah jumlah barang yang ada dalam satu koli.",
                          footer: "",
                          style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.8em"}
                        }, null, 512), [
                          [_vShow, _ctx.isOpenTooltipPiecePerPack]
                        ])
                      ])
                    ]),
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.manualBooking.piecePerPack,
                      "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => (_ctx.manualBooking.piecePerPack = $event)),
                      format: _ctx.formatPiecePerPack,
                      placeholder: "Masukan piece per pack",
                      errorIcon: false,
                      error: _ctx.errorMandatory[16],
                      errorCaption: 'Piece per pack wajib diisi',
                      onFocus: _cache[62] || (_cache[62] = ($event: any) => (_ctx.setFieldIndex(16)))
                    }, null, 8, ["modelValue", "format", "error"])
                  ]),
                  _createVNode("div", _hoisted_127, [
                    _createVNode("div", _hoisted_128, [
                      _hoisted_129,
                      _hoisted_130,
                      _createVNode("div", _hoisted_131, [
                        _createVNode("img", {
                          onMouseenter: _cache[63] || (_cache[63] = ($event: any) => (_ctx.isOpenTooltipNextCommodity = true)),
                          onMouseleave: _cache[64] || (_cache[64] = ($event: any) => (_ctx.isOpenTooltipNextCommodity = false)),
                          src: 
                      _ctx.isOpenTooltipNextCommodity
                        ? require('@/app/ui/assets/svg/info-red.svg')
                        : require('@/app/ui/assets/svg/info.svg')
                    ,
                          alt: ""
                        }, null, 40, ["src"]),
                        _withDirectives(_createVNode(_component_Tooltip, {
                          title: "Komoditas Selanjutnya",
                          message: "Isi dengan komoditas barang yang ada dalam satu koli.",
                          footer: "",
                          style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.8em"}
                        }, null, 512), [
                          [_vShow, _ctx.isOpenTooltipNextCommodity]
                        ])
                      ])
                    ]),
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.manualBooking.nextCommodity,
                      "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => (_ctx.manualBooking.nextCommodity = $event)),
                      placeholder: "Masukan komoditas selanjutnya",
                      error: _ctx.errorMandatory[17],
                      errorCaption: 'Komoditas selanjutnya wajib diisi',
                      onFocus: _cache[66] || (_cache[66] = ($event: any) => (_ctx.setFieldIndex(17))),
                      onBlur: _cache[67] || (_cache[67] = ($event: any) => (_ctx.setFieldIndex(18)))
                    }, null, 8, ["modelValue", "error"])
                  ])
                ]),
                _hoisted_132
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      footer: _withCtx(() => [
        (_ctx.isVendorNinjaDestination)
          ? (_openBlock(), _createBlock("div", _hoisted_133, " Area vendor " + _toDisplayString(_ctx.manualBooking.destinationCity?.type?.toLowerCase() ===
          "vendor_lanjutan"
            ? "lanjutan"
            : "") + " " + _toDisplayString(_ctx.manualBooking.destinationCity?.vendor_code?.toLowerCase() === "nx" ? '(Ninja)': '(POS Indonesia)') + " maks. 1 koli ", 1))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_134, [
          (_ctx.prefixAlgoEstimationShow(_ctx.shipmentId))
            ? (_openBlock(), _createBlock(_component_DetailCalculation, {
                key: 0,
                isBooking: true,
                isDisabled: 
            !_ctx.isFormValid ||
              _ctx.validateTotalGrossWeight ||
              _ctx.isDisabledButton ||
              _ctx.validateTotalVolumeWeight
          ,
                bookingType: "addAddress",
                payload: _ctx.payload,
                accountRefAndCommodity: _ctx.accountRefAndCommodity,
                isShowArrow: false,
                isFromBooking: false
              }, null, 8, ["isDisabled", "payload", "accountRefAndCommodity"]))
            : (_openBlock(), _createBlock(_component_DetailUncalculation, {
                key: 1,
                isBooking: true,
                isDisabled: 
            !_ctx.isFormValid ||
              _ctx.validateTotalGrossWeight ||
              _ctx.isErrorCity ||
              _ctx.isErrorCommodity ||
              _ctx.isShipperAndConsigneeAddressIdentical ||
              _ctx.isDisabledButton ||
              _ctx.validateTotalVolumeWeight
          ,
                bookingType: "addAddress",
                payload: _ctx.payload,
                accountRefAndCommodity: _ctx.accountRefAndCommodity,
                isShowArrow: false,
                isFromBooking: false,
                onUpdateStatusErrorEmbargo: _ctx.updateStatusErrorEmbargo
              }, null, 8, ["isDisabled", "payload", "accountRefAndCommodity", "onUpdateStatusErrorEmbargo"]))
        ])
      ]),
      _: 1
    }, 8, ["title", "onClose"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: 
      () => {
        _ctx.setEditTerminated(false);
        _ctx.setAddNewDestination(false);
      }
    ,
      onClose: () => _ctx.setEditTerminated(false),
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.closeModalError,
      title: _ctx.titleErrorspesification,
      message: _ctx.errorCause,
      image: "image-modal-warning",
      textSuccess: "OK",
      class: "px-8"
    }, null, 8, ["onSubmit", "title", "message"]), [
      [_vShow, _ctx.isErrorAdd && _ctx.isErrorSpesificRate]
    ]),
    (_ctx.isErrorAdd && !_ctx.isErrorSpesificRate)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          errorType: _ctx.errorCause,
          onCancel: _ctx.closeModalError,
          onTryAgain: _ctx.booking,
          modal: ""
        }, null, 8, ["errorType", "onCancel", "onTryAgain"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: "Pembuatan Booking Baru Berhasil !",
      message: `${this.messageSuccess}`,
      image: "image-modal-success",
      textSuccess: "OK",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ])
  ], 64))
}